import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useRecoilState } from 'recoil'
import { STORAGE_TOKEN_KEY } from '../api/constant'
import { dataCorporateList, fetchDataCorporateList } from '../store'

export default function useFetchDataCorporate(setLoading) {
  const [corporateList, setCorporateList] = useRecoilState(dataCorporateList)

  const history = useHistory()

  useEffect(() => {
    let isApiSubscribed = true
    if (isApiSubscribed) {
      if (!corporateList.length) {
        setLoading(true)
        fetchDataCorporateList((data, err) => {
          if (data) {
            setCorporateList(data)
            setLoading(false)
            if (!data.length) {
              isApiSubscribed = false
            }
          } else {
            if (err.redirect) {
              localStorage.removeItem(STORAGE_TOKEN_KEY)
              history.push('/login')
              setLoading(false)
            }
          }
        })
      }
    }

    return () => {
      // cancel the subscription
      isApiSubscribed = false
    }
  }, [setLoading, history, corporateList.length, setCorporateList])

  return { corporateList }
}
